import { createContext, useContext } from 'react';
import { AddFramesDirection } from '@/generated/graphql'; // Ensure correct import path for generated types

export interface UploadJob {
    animationId: number;
    animationTitle: string;
    allFiles: File[];
    currentBatchIndex: number;
    direction: AddFramesDirection;
    autoPublishPanel: number;
}

export interface ContextType {
    activeJob: UploadJob | null;
    startUpload: (
        animationId: number,
        animationTitle: string,
        files: FileList,
        direction?: AddFramesDirection,
        autoPublishPanel?: number,
    ) => void;
    currentBatch: number;
    totalBatches: number;
}

// Global context token instance
export const AnimationAddFramesContext = createContext<ContextType | undefined>(
    undefined,
);

// The safe hook stays in the main chunk but has zero heavy dependencies
export const useAnimationAddFrames = () => {
    const context = useContext(AnimationAddFramesContext);
    if (!context) {
        return {
            activeJob: null,
            startUpload: () => {},
            currentBatch: 0,
            totalBatches: 0,
        };
    }
    return context;
};
